var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMaterial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 73,
    viewBox: "0 0 79 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xEB\xA0\x88\xEC\x9D\xB4\xEC\x96\xB4_1",
    clipPath: "url(#clip0_487_918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.8617 9.17304L10.7227 20.8572L59.9821 63.6024L70.1212 51.9182L20.8617 9.17304Z",
    fill: "#21AFD3",
    stroke: "#231916",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.139 5.06982L6 16.754L10.7281 20.8568L20.8671 9.17262L16.139 5.06982Z",
    fill: "#FFFDF5",
    stroke: "#231916",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.17465 7.06354L5.99564 2.66025C7.739 0.651202 10.7861 0.435457 12.7951 2.17882L16.1335 5.07569L5.99443 16.7599L2.65608 13.863C0.647034 12.1197 0.431289 9.07259 2.17465 7.06354Z",
    fill: "#F5D039",
    stroke: "#231916",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M70.1205 51.93L59.9805 63.61L69.7505 66.12L73.9805 61.24L70.1205 51.93Z",
    fill: "#FFFDF5",
    stroke: "#231916",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M73.98 61.24L69.75 66.12L76.75 67.93L73.98 61.24Z",
    fill: "#073391",
    stroke: "#231916",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M23.6119 49.17C22.6519 48.23 17.7719 50.55 17.0519 50.91C13.2919 52.8 10.5519 55.91 8.69187 59.65C7.28187 62.49 6.57188 67.64 2.42188 67.67C2.42188 67.67 22.7719 80.41 30.7319 56.12C30.7319 56.12 23.6119 49.17 23.6019 49.16L23.6119 49.17Z",
    fill: "#E3650E",
    stroke: "#231916",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M41.212 44.97L34.082 38.01L66.362 3.3C68.902 0.570004 73.042 0.260004 75.522 2.68C78.012 5.11 77.802 9.25 75.132 11.85L41.212 44.96V44.97Z",
    fill: "#BF7B19",
    stroke: "#231916",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M41.2013 44.9678L34.0742 38.0104L23.3866 48.9586L30.5136 55.9161L41.2013 44.9678Z",
    fill: "#FFFDF5",
    stroke: "#231916",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_487_918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 78.27,
    height: 72.02,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMaterial);
export default __webpack_public_path__ + "static/media/icon-material.f1ab6a46752229c1f9279797bcb4a604.svg";
export { ForwardRef as ReactComponent };